import { render, staticRenderFns } from "./DangerIcon.vue?vue&type=template&id=021ddaa6&scoped=true"
import script from "./DangerIcon.vue?vue&type=script&lang=js"
export * from "./DangerIcon.vue?vue&type=script&lang=js"
import style0 from "./DangerIcon.vue?vue&type=style&index=0&id=021ddaa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ddaa6",
  null
  
)

export default component.exports